import * as o from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/MapPinPlus.es.js";
const a = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(s, { ref: r, ...e, weights: t }));
a.displayName = "MapPinPlusIcon";
const m = a;
export {
  m as MapPinPlus,
  a as MapPinPlusIcon
};
